import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  DEFAULT_NOTIFICATION_SETTINGS,
  useNotificationSetting,
} from "../hooks/useNotificationSetting";

/***************************************************
 *********** Define defaults of the state *********
 **************************************************/

const GlobalContext = createContext({
  notificationSettings: DEFAULT_NOTIFICATION_SETTINGS,
  notificationSettingsLoaded: false,
  setNotificationSettings: () => {},
  loadNotificationSettings: async () => DEFAULT_NOTIFICATION_SETTINGS,
});

export const GlobalContextProvider = ({ children }) => {
  /*****************************************************
   ********** Define All global state here *************
   ****************************************************/

  const notificationContext = useNotificationSetting();

  const globalContext = useMemo(
    () => ({
      ...notificationContext,
    }),
    [notificationContext],
  );

  return (
    <GlobalContext.Provider value={globalContext}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  if (!useContext) {
    console.error(
      "useGlobalContext must be used within a GlobalContextProvider",
    );
  }
  return useContext(GlobalContext);
};
